import * as React from 'react';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkHeading } from 'uitk-react-text';
import { ActivityDestinationViewSearch, ActivityUdsToken } from '../../../common/__generated__/api';
import { ActivityKeywordSearchInput } from '../../../components/common/activity-keyword-search-input';
import { useStores } from '../../../utils/hooks';
import { Checkbox } from './checkbox';
import { Radio } from './radio';
import { RangeCheckbox } from './range-checkbox';
import SortAndFilterSections = ActivityDestinationViewSearch.SortAndFilterSections;
import Fields = ActivityDestinationViewSearch.Fields;

export interface SortFilterProps {
  loading?: boolean;
  inDialog?: boolean;
}

export const SortFilter: React.FC<SortFilterProps> = ({ loading, inDialog }) => {
  const { activitySearchStore } = useStores();
  const sortAndFilterSections = activitySearchStore.sortAndFilter?.sortAndFilterSections;
  const sortAndFilterObj = activitySearchStore.sortAndFilterObject;

  const sortAndFilterFeilds = (field: Fields, sectionName?: string | null): JSX.Element => {
    switch (field.udsToken) {
      case ActivityUdsToken.SINGLE_SELECT:
        return (
          <Radio
            inDialog={inDialog}
            selectedField={sortAndFilterObj.initialSelectedSort}
            field={field}
            sectionName={sectionName}
          />
        );
      case ActivityUdsToken.TEXT:
        return <ActivityKeywordSearchInput inDialog={inDialog} />;
      case ActivityUdsToken.MULTI_SELECT_LIST:
        return <Checkbox inDialog={inDialog} field={field} />;
      case ActivityUdsToken.MULTI_SELECT_RANGE:
        return <RangeCheckbox inDialog={inDialog} field={field} />;
      default:
        return <></>;
    }
  };

  const sortAndFilterSection = (): JSX.Element =>
    sortAndFilterSections.map((sortAndFilterObj: SortAndFilterSections, index: number) => (
      <section className="all-b-padding-four all-b-margin-four uitk-card-separator-bottom" key={index}>
        {sortAndFilterObj.title && (
          <UitkHeading
            tag="h2"
            size={5}
            className="all-b-padding-two uitk-type-bold"
            data-testid="filter-section--header"
          >
            {sortAndFilterObj.title}
          </UitkHeading>
        )}

        {sortAndFilterObj.fields &&
          sortAndFilterObj.fields.map((field: Fields, index: number) => (
            <div key={`${field.id}-${index}`} data-testid={`sort-filter-${field.id}-field`}>
              {sortAndFilterFeilds(field, sortAndFilterObj.title)}
            </div>
          ))}
      </section>
    ));

  return (
    <UitkLayoutGrid columns={1}>
      <UitkLayoutGridItem colSpan="all" className="form-truncate">
        <fieldset aria-busy={loading} data-testid="sort-filter--fieldset">
          {sortAndFilterSections && sortAndFilterSection()}
        </fieldset>
      </UitkLayoutGridItem>
    </UitkLayoutGrid>
  );
};
